import { render, staticRenderFns } from "./OnsFormGroup.vue?vue&type=template&id=1207598e&"
import script from "./OnsFormGroup.vue?vue&type=script&lang=js&"
export * from "./OnsFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports